// Just a wrapper helper for responsive bem modifiers.

// const responsiveBem = makeResponsiveBem("DocumentPicker");
// responsiveBem("container");
// => "DocumentPicker__container DocumentPicker__container--xs"
//
// responsiveBem(null);
// => "DocumentPicker--xs"

import classnames from "classnames";

import { getBreakpoint } from "Common/Responsive";

import makeBem from "./makeBem";

export default (block: string) => (element: string | null | undefined) => {
  const bem = makeBem(block);
  if (element === undefined || element === null) {
    return classnames(bem(), bem(null, getBreakpoint()));
  }
  return classnames(bem(element), bem(element, getBreakpoint()));
};
